"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpBaseClient = void 0;
/**
 * This is a very simple HTTP client that can be used to make requests to an API.
 * The main function it has is mapping request options to a URL and making the request.
 * It implements the RequestClient interface, so the generated clients can use it.
 * The actual requestClient (for example, fetch) should be passed in the constructor.
 *
 * This client replaces path params and adds query params to the URL.
 */
class HttpBaseClient {
    /** Configure Request Client with your own client. */
    constructor(baseUrl, requestClient, options) {
        this.baseUrl = baseUrl;
        this.requestClient = requestClient;
        this.options = options;
    }
    getQueryString(params) {
        const qs = [];
        const append = (key, value) => {
            qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
        };
        const encodePair = (key, value) => {
            if (value === undefined || value === null) {
                return;
            }
            if (this.options?.removeEmptyStringQueryParams && value === '') {
                return;
            }
            if (value instanceof Date) {
                append(key, value.toISOString());
            }
            else if (Array.isArray(value)) {
                value.forEach((v) => encodePair(key, v));
            }
            else if (typeof value === 'object') {
                Object.entries(value).forEach(([k, v]) => encodePair(`${key}[${k}]`, v));
            }
            else {
                // TODO: Do we need to handle other types?
                append(key, value);
            }
        };
        Object.entries(params).forEach(([key, value]) => encodePair(key, value));
        return qs.length ? `?${qs.join('&')}` : '';
    }
    getUrlWithReplacedPathParams(options) {
        // Regex is bounded to find path parameters of a maximum of 25 characters to avoid super-linear runtime due to backtracking
        const path = options.url.replace(/{([^}]{1,25})}/g, (substring, group) => {
            if (options.path && Object.hasOwn(options.path, group)) {
                return String(options.path[group]);
            }
            return substring;
        });
        const queryString = this.getQueryString(options.query || {});
        const pathPrefix = path.startsWith('/') ? '' : '/';
        return `${this.baseUrl}${pathPrefix}${path}${queryString}`;
    }
    async makeRequest(data, headerOverrides) {
        const url = this.getUrlWithReplacedPathParams(data);
        const options = {
            ...data,
            headers: {
                'Content-Type': 'application/json',
                ...data.headers,
                ...headerOverrides,
            },
        };
        return this.requestClient(url, options);
    }
}
exports.HttpBaseClient = HttpBaseClient;
